import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="m5 2 2 3 3 2-3 2-2 3-2-3-3-2 3-2 2-3ZM10 0l1 1 1 1-1 1-1 1-1-1-1-1 1-1 1-1Z"/>',
  f: '<path d="m5 2 2 3 3 2-3 2-2 3-2-3-3-2 3-2 2-3ZM10 0l1 1 1 1-1 1-1 1-1-1-1-1 1-1 1-1Z"/>',
  vb: '0 0 13 13',
};

export default data;
